import { Alert, Button, Flex } from 'antd';

import { MCP_INTEGRATION_LABEL } from '@app/constants/navigation';

import { IframePage } from '@pages/IframePage';

import {
  MCP_ERROR_MESSAGES,
  MCP_HANDSHAKE_TIMEOUT_DESCRIPTION,
  MCP_HANDSHAKE_TIMEOUT_MESSAGE,
  MCP_RETRY_LABEL,
} from '../constants';
import { useMcpIntegration } from '../hooks/useMcpIntegration';

import type { FC } from 'react';

import './McpIntegration.scss';

export const McpIntegration: FC = () => {
  const {
    host,
    error,
    frameKey,
    isHandshakeTimedOut,
    messageHandler,
    retryHandler,
  } = useMcpIntegration();

  if (error) {
    return <Alert type="error" showIcon message={MCP_ERROR_MESSAGES[error]} />;
  }

  return (
    <Flex vertical gap="middle" className="McpIntegration">
      {isHandshakeTimedOut && (
        <Alert
          type="warning"
          showIcon
          message={MCP_HANDSHAKE_TIMEOUT_MESSAGE}
          description={MCP_HANDSHAKE_TIMEOUT_DESCRIPTION}
          action={<Button onClick={retryHandler}>{MCP_RETRY_LABEL}</Button>}
        />
      )}
      <IframePage
        key={frameKey}
        host={host}
        title={MCP_INTEGRATION_LABEL}
        withJwt={false}
        withContextInUrl={false}
        isEmbedded
        onMessage={messageHandler}
      />
    </Flex>
  );
};
